<script setup lang="ts">
import { computed, watch } from "vue"
import { TransitionChild, TransitionRoot } from "@headlessui/vue"
import { XIcon } from "@heroicons/vue/outline"
import { useSlideOver } from "@/stores/slideOver"

const slideOverStore = useSlideOver()
const isOpen = computed(() => slideOverStore.isOpen)
const items = computed(() => slideOverStore.items)

function handleCloseSlideOver() {
  slideOverStore.closeSlideOver()
}

watch(isOpen, () => {
  if (isOpen.value) {
    document.documentElement.style.overflowY = "hidden"
  } else {
    document.documentElement.style.overflowY = "auto"
  }
})
</script>

<template>
  <TransitionRoot as="div" :show="isOpen">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="relative z-50"
      aria-labelledby="slide-over-title"
      role="dialog"
      aria-modal="true"
    >
      <div class="fixed inset-0" @click="handleCloseSlideOver"></div>

      <div
        class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10"
      >
        <TransitionChild
          enter="transform transition ease-in-out duration-500 sm:duration-700"
          enter-from="translate-x-full"
          enter-to="translate-x-0"
          leave="transform transition ease-in-out duration-500 sm:duration-700"
          leave-from="translate-x-0"
          leave-to="translate-x-full"
        >
          <div class="pointer-events-auto relative w-screen max-w-2xl h-full">
            <div
              class="flex h-full flex-col overflow-y-scroll styled-scroll bg-gray-800 py-6 shadow-[0px_0px_54px_rgba(0,0,0,0.5)] border-l-[9px] border-primary"
            >
              <div class="px-4 sm:px-6">
                <div
                  :class="[
                    'flex items-center border-b border-gray-700 pb-[18px]',
                    item.header ? 'justify-between' : 'justify-end'
                  ]"
                >
                  <div v-if="item.header">
                    <component :is="item.header" />
                  </div>
                  <div class="ml-3 flex h-7 items-center">
                    <button
                      type="button"
                      class="rounded-md bg-transparent text-primary hover:text-primary-200 transition-all focus:outline-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
                      @click="handleCloseSlideOver"
                    >
                      <span class="sr-only">Close panel</span>
                      <XIcon class="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="relative mt-6 flex-1 px-4 sm:px-6">
                <component :is="item.content" />
              </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </div>
  </TransitionRoot>
</template>
